import React, { useEffect, forwardRef } from 'react';
import SignaturePad from 'signature_pad';

const SignaturePadComponent = forwardRef((props, ref) => {
  const { width = 500, height = 200 } = props;

  useEffect(() => {
    const canvas = ref.current;

    const resizeCanvas = () => {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    };

    resizeCanvas();

    canvas.signaturePad = new SignaturePad(canvas, {
      penColor: 'black',
      backgroundColor: 'white',      
    });
  }, [width, height]);

  return (
    <canvas
      ref={ref}
      width={width}
      height={height}
      style={{
        border: '2px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#fff',
        width: `${width}px`,
        height: `${height}px`,
        maxWidth: '100%',
      }}
    />
  );
});

export default SignaturePadComponent;